module.exports = __webpack_public_path__ + "static/media/start-to-learn.405077d5.jpg";